<template>
  <Catalogs
    title="Вакансии"
    create-text="Новая"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'VacancyAdd'"
    :route-edit="'VacancyEdit'"
    :route-view="'VacancyView'"
    :route-path="'/vacancies'"
    :can-edit="canEditVacancyCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "Vacancies",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'vacancies-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'vacancies-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getVacancies(data);
    },
    canEditVacancyCatalogs() {
      return this.hasPermission([PERM.CATALOG_VACANCY_EDIT]);
    }
  }
}
</script>

<style>
.vacancies-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.vacancies-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Vacancies/Vacancies.vue